module.exports = __webpack_public_path__ + "static/media/zone_1.92ce4dce.png";